import src from "IMAGE";
export default { src, width: 152, height: 20, blurWidth: 0, blurHeight: 0};
